import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { IAppPropsWithRoute } from "../../common/types";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import homepageLogo from "../../assets/images/homepage-logo.png";
import themeDark from "../shared/themeDark";
import { Paper, Grid, Box } from "@material-ui/core";
import CalloutButton from "./CalloutButton";
import IButtonSettings from "./types/IButtonSettings";
import alertCircle from "../../assets/svgs/alert-circle.png";
import alertTriangle from "../../assets/svgs/alert-triangle.png";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import api from "../../store/api";
import { formatDistanceToNowStrict } from "date-fns";
import Brightness1 from "@material-ui/icons/Brightness1";
import { ClassNameMap } from "@material-ui/styles";
import ErrorMessage from "../shared/messages/ErrorMessage";
import RequestCalloutTypes from "./types/RequestCalloutTypes";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";
import { createMuiTheme } from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Navbar from "../shared/Navbar";
import { useDispatch } from "react-redux";
import LinearProgress from '@material-ui/core/LinearProgress';
interface RequestCalloutWidgetProps extends IAppPropsWithRoute {
  setShowLogo: React.Dispatch<React.SetStateAction<boolean>>;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    //height: "100%",
    padding: 0,
    margin: 0,
    fontFamily: "Lato",
    backgroundImage: "linear-gradient(180deg, #0049a3, #00152E)",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
    //borderRadius: 0,
    //flex: 1,
  },
  main: {
    width: "100%",
    height: "100%",
    minHeight: "calc(100vh - 60px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    "& .mainBody": {
      "& .logoSec": {
        marginBottom: "60px",
        //marginTop: "30px",
        "& img": {
          height: "65px",
        },
      },
      "& .calloutSec": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "60px",
        marginBottom: "45px",
      },
      "& .locationSec": {
        marginTop:"24px",
        "& .nameBlock": {
          fontSize: "18px",
          fontWeight: 700,
          fontStyle: "Bold",
          color: "#FFFFFF",
          marginBottom: "12px",
        },
        "& .changeBtn": {
          fontSize: "15px",
          fontWeight: 400,
          fontStyle: "Regular",
          color: "#F4B827",
          cursor: "pointer",
        },
      },
    },
  },
  betweenLocationWardIcon: {
    width: "7px",
    height: "7px",
  },
  betweenLocationWardIconSpan: {
    display: "inline-block",
    overflow: "hidden",
    margin: "0px 17px",
  },
  loading: {
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2),
    },
},
}));

const overLoadedButtonSettings: IButtonSettings = {
  firstLabel: "We’re",
  secondLabel: "Overloaded",
  color: "#F4B827",
  icon: alertCircle,
};

const incidentButtonSettings: IButtonSettings = {
  firstLabel: "We Have",
  secondLabel: "An Incident",
  color: "#F15454",
  icon: alertTriangle,
};

const createBetweenLocationWardIcon = (classes: ClassNameMap) => (
  <div className={classes.betweenLocationWardIconSpan}>
    <Brightness1 className={classes.betweenLocationWardIcon} />
  </div>
);

const RequestCalloutWidget: React.FC<RequestCalloutWidgetProps> = (props) => {
  const { setShowLogo } = props;
  const classes = useStyles();
  const { authStore } = useSelector((state: RootState) => state);
  const [lastCalloutOverloaded, setLastCalloutOverloaded] = React.useState("");
  const [lastCalloutIncedent, setLastCalloutIncedent] = React.useState("");
  const [wardName, setWardName] = React.useState("");
  const [locationName, setLocatiodName] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [changeward, setchangeward] = React.useState(true);
  const [wardid, setwardid] = React.useState("");
  const [locationid, setlocationid] = React.useState("");
  const [checkward, setcheckward] = React.useState(true);
  const [openward, setopenward] = React.useState(true);
  React.useEffect(() => {
    setShowLogo(changeward);
  }, [setShowLogo, changeward]);

  const getCalloutInitialData = async (): Promise<void> => {
    setErrorMessage("");
    setLoading(true);
    var checkward =  localStorage.getItem("Reqcallout:Checkward");
    if(checkward === "True")
    {
      setchangeward(false);
      setopenward(false);
    }
    if(authStore.data?.ward !== null && authStore.data?.ward !== undefined && authStore.data.ward !==""){
      setchangeward(false);
      setopenward(false);
      setcheckward(false);
    }
    const res = await api.getCalloutLastRequestedDates("", {});
    const resModel = res?.data?.model;
    if (resModel) {
      setLastCalloutOverloaded(
        resModel.lastCalloutOverloadedDate
          ? formatDistanceToNowStrict(
              new Date(resModel.lastCalloutOverloadedDate)
            )
          : ""
      );
      setLastCalloutIncedent(
        resModel.lastCalloutIncedentDate
          ? formatDistanceToNowStrict(
              new Date(resModel.lastCalloutIncedentDate)
            )
          : ""
      );
      if (
        localStorage.getItem("Reqcallout:LocationName") !== null &&
        localStorage.getItem("Reqcallout:WardName") !== null &&
        authStore.data?.IsCustomer
      ) {
        var locname = localStorage.getItem("Reqcallout:LocationName");
        var wname = localStorage.getItem("Reqcallout:WardName");
        var locid = localStorage.getItem("Reqcallout:LocationId");
        var wid = localStorage.getItem("Reqcallout:WardId");
        setWardName(wname ?? "");
        setLocatiodName(locname ?? "");
        setwardid(wid ?? "");
        setlocationid(locid ?? "");
        setcheckward(false);
      } else {
        if (localStorage.getItem("Reqcallout:WardName") !== null) {
          var wname = localStorage.getItem("Reqcallout:WardName");
          setWardName(wname ?? "");
        } else {
          setWardName(resModel.wardName);     
        }
        setLocatiodName(resModel.locationName);
        if (resModel.wardName === "") {
          setcheckward(false);
          setopenward(true);
        } else {
          setcheckward(true);
        }
        if (localStorage.getItem("Reqcallout:WardName") !== null) {
          var wname = localStorage.getItem("Reqcallout:WardName");
          setopenward(false);
        }
      }
    }
    setLoading(false);
  };

  const createCallout = async (calloutType: number) => {
    setLoading(true);
    try {     
      setErrorMessage("");
      localStorage.setItem("Reqcallout:Checkward","True");
      if (((authStore.data?.ward !== "" && authStore.data?.ward !== undefined) || wardid !== "") && ((authStore.data?.location !== "" && authStore.data?.location !== undefined) || locationid !== "")) {
        const res = await api.addCalloutRequest("", {
          locationId:
            authStore.data && !authStore.data.IsCustomer
              ? authStore.data?.location
              : locationid
              ? locationid
              : null,
          wardId:
            authStore.data?.ward && !authStore.data.IsCustomer
              ? authStore.data?.ward
              : wardid
              ? wardid
              : null,
          type: calloutType,
        });
        const requestCalloutId = res?.requestCalloutId;
        if (requestCalloutId) {
          setLoading(false);
          props.history.push(`/calloutrequested/${requestCalloutId}`);
        } else {
          throw "wrong response";
        }
      } else {
        throw "wrong response";
      }
    } catch (error) {
      setErrorMessage("Error while adding callout");
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getCalloutInitialData();
  }, [authStore]);

  React.useMemo(() => {
    if (!changeward) {     
      setErrorMessage("");
      if (
        localStorage.getItem("Reqcallout:LocationName") !== null &&
        localStorage.getItem("Reqcallout:WardName") !== null
      ) {
        var locname = localStorage.getItem("Reqcallout:LocationName");
        var wname = localStorage.getItem("Reqcallout:WardName");
        var locid = localStorage.getItem("Reqcallout:LocationId");
        var wid = localStorage.getItem("Reqcallout:WardId");
        setWardName(wname ?? "");
        setLocatiodName(locname ?? "");
        setwardid(wid ?? "");
        setlocationid(locid ?? "");
        setcheckward(false);
        setopenward(false);
        setLoading(false);
      }
    }
  }, [changeward]);


  const home = (): void => {
    props.history.push("/");
  };

  return (
    <MuiThemeProvider theme={themeDark}>
      <Paper className={classes.root}>
        {!changeward && !openward ? (
          <div className={classes.main}>
            <div className="mainBody">            
              <div className="logoSec">
                <img src={homepageLogo} onClick={home} alt="" />
              </div>
              <div className="calloutSec">
                <div>
                  <CalloutButton
                    buttonSettings={overLoadedButtonSettings}
                    lastCallout={lastCalloutOverloaded}
                    calloutType={RequestCalloutTypes.overloadedCallout}
                    createCallout={createCallout}
                    loading={loading}
                  />
                </div>
                <div>
                  <CalloutButton
                    buttonSettings={incidentButtonSettings}
                    lastCallout={lastCalloutIncedent}
                    calloutType={RequestCalloutTypes.incidentCallout}
                    createCallout={createCallout}
                    loading={loading}
                  />
                </div>
              </div>
              {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
              <div className="locationSec">
                {locationName || wardName ? (
                  <>
                    <div className="nameBlock">
                      {locationName}{" "}
                      {wardName && createBetweenLocationWardIcon(classes)}{" "}
                      {wardName}
                    </div>
                    {authStore.data?.IsCustomer || !checkward ? (
                      <Box
                        className="changeBtn"
                        onClick={() => setchangeward(true)}
                      >
                        Change Ward
                      </Box>
                    ) : null}
                  </>
                ) :  
               authStore.data?.ward === "" ?                 
                  <Box
                    className="changeBtn"
                    onClick={() => setchangeward(true)}
                  >
                    Change Ward
                  </Box>:null
                }
              </div>
            </div>
          </div>
        ) : (
          <ChangewardModal
            customerid={authStore.data?.CustomerId || ""}
            onClose={({ reload = false }) => {
              setchangeward(false);
            }}
            setLocatiodName={setLocatiodName}
            setWardName={setWardName}
            setlocationid={setlocationid}
            setwardid={setwardid}
            Locationid={locationid}
            Openward={openward}
            setopenward={setopenward}
          />
        )}
         <div style={{ paddingTop: 20, paddingBottom: 20, }}>
            {loading ? <CreateLoadingLine /> : null}
          </div>
      </Paper>
    </MuiThemeProvider>
  );
};

const theme = createMuiTheme({
  overrides: {
    MuiDialog: {
      paperFullWidth: {
        width: "100%",
        height: "100%",
        margin: 0,
        maxHeight: "100%",
        borderRadius: 0,
        backgroundColor: "#000d2a",
      },
    },
    MuiDialogTitle: {
      root: {
        color: "#fff",
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff",
      },
    },
    MuiDialogContent: {
      dividers: {
        borderTop: "1px solid rgba(255, 255, 255, 0.12)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
        flex: "0 1 auto",
      },
    },
  },
});

const useStylesward = makeStyles({
  headerTitle: {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: 400,
  },
  centeredContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  contentContainer: {
    width: "100%",
    //maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 59px)",
    backgroundColor: "rgb(0,21,46)",
  },
  timerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0,
    padding: "15px 15px",
    backgroundColor: "#00152E",
    position: "fixed",
    top: "59px",
    left: 0,
    zIndex: 1200,
  },
  heading: {
    fontWeight: 900,
    fontSize: "38px",
    color: "#fff",
  },
  body: {
    width: "100%",
    margin: 0,
    marginTop: "100px",
    padding: 0,
  },
  note: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0,
    padding: "15px 15px",
    fontSize: "26px",
    color: "#fff",
    opacity: "0.5",
  },
  closeIcon: {
    position: "absolute",
    top: "70px",
    right: "10px",
  },
  reasonsList: {
    margin: "8px 0px",
    padding: 0,
  },
  reasonItem: {
    backgroundColor: "#D8D8D810",
    height: 60,
    borderRadius: 6,
    display: "flex",
    justifyContent: "space-between",
    fontSize: 30,
    color: "#fff",
    listStyle: "none",
    marginBottom: 6,
    alignItems: "center",
    padding: "0 20px",
    cursor: "pointer",
  },
  waitingHeading: {
    fontWeight: 700,
    fontSize: "38px",
    color: "#fff",
    margin: "50px 0 10px",
  },
  waitingReason: {
    fontSize: "24px",
    color: "#fff",
  },
  timer: {
    fontWeight: 900,
    fontSize: "65px",
    color: "#fff",
    margin: "105px 0 135px",
  },
  stopButton: {
    fontWeight: 700,
    fontSize: "19px",
    color: "#131415",
    borderRadius: 4,
    backgroundColor: "#fff",
    height: 55,
    width: 199,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  cancelButton: {
    marginTop: 14,
    fontWeight: 700,
    fontSize: "19px",
    color: "#fff",
    height: 55,
    width: 199,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  saveButton: {
    marginRight: "16px",
    marginTop: "19px",

    "@media (max-width: 1024px)": {
      marginTop: "0",
    },
  },
});
interface ChangewardModalProps {
  onClose: any;
  customerid: any;
  setLocatiodName: any;
  setWardName: any;
  setwardid: any;
  setlocationid: any;
  Locationid: any;
  Openward:any;
  setopenward:any;
}

type wards = {
  wardId: any;
  name: any;
  locationName: any;
  locationId: any; 
};

const ChangewardModal = ({
  onClose,
  customerid,
  setLocatiodName,
  setWardName,
  setwardid,
  setlocationid,
  Locationid,
  Openward,
  setopenward,

}: ChangewardModalProps) => {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [wardlst, setwardlst] = useState<wards[]>([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    setLoading(true);
    if (customerid !== null && customerid !== "") {
      api.getwardbyCustomer("Customerid=" + customerid).then((resp) => {
        if (resp.data !== null && resp.data.result !== null) {
          setwardlst(resp.data.result);
        } else {
          setIsError(true);
        }
        setIsLoading(false);
        setLoading(false);
      });
    } else {
      api.getwardbyLocation().then((resp) => {
        if (resp.data !== null && resp.data.result !== null) {
          setwardlst(resp.data.result);
        } else {
          setIsError(true);
        }
        setIsLoading(false);
        setLoading(false);
      });
    }
  }, []);
  const switchward = (
    wardname: any,
    locationname: any,
    locationId: any,
    wardId: any
  ) => {
    setLocatiodName(locationname);
    setWardName(wardname);
    setwardid(wardId);
    setlocationid(locationId);
    localStorage.setItem("Reqcallout:LocationId", locationId);
    localStorage.setItem("Reqcallout:WardId", wardId);
    localStorage.setItem("Reqcallout:LocationName", locationname);
    localStorage.setItem("Reqcallout:WardName", wardname);
    setopenward(false);
    onClose(true);
  };
  const classes = useStylesward();
  return (
    <div>
      {!isLoading && !isError && (
        <div className={classes.contentContainer}>
          {wardlst.length > 0 ? (
            <>
              <div className={classes.header}>
                <div className={classes.heading}>Choose a ward</div>
                {!Openward?
                <IconButton style={{marginRight:"20px",marginTop:"10px"}} aria-label="close" onClick={onClose}>
                  <CloseIcon style={{fontSize:"2.4rem"}} fontSize="large" />
                </IconButton>:null}
              </div>
              <div className={classes.body}>
                <ul className={classes.reasonsList}>
                  {wardlst.map((ward) => {
                    return (
                      <li
                        key={ward.wardId}
                        className={classes.reasonItem}
                        onClick={() => {
                          switchward(
                            ward.name,
                            ward.locationName,
                            ward.locationId,
                            ward.wardId
                          );
                        }}
                      >
                        {ward.locationName} / {ward.name}{" "}
                        <ArrowForwardIosIcon />
                      </li>
                    );
                  })}
                </ul>
              </div>
            </>
          ) : (
            <div className={classes.note}>
              <div>No wards available</div>         
            </div>
          )}       
        </div>
      )}
       <div className={classes.contentContainer}>
      <div style={{ paddingTop: 20, paddingBottom: 20, }}>
            {loading ? <CreateLoadingLine /> : null}
          </div>
    </div></div>
  );
};
const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
      <div className={classes.loading}>
          <LinearProgress color="primary" />
      </div>
  )
}
export default React.memo(withRouter(RequestCalloutWidget));
